import { defaultStoreUtils } from '@databases/redux';
import { loadDependenciesAsync } from '@databases/utils/database/field-types';
import { getFilteredValuesWithContext } from '@databases/utils/database/view/view';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import { useEffect } from 'react';
import { useIntl } from 'react-intl-next';

import useView from '../hooks/useView';

export const useFilteredValues = ({ contentId }: { contentId: string }) => {
  const { view } = useView();
  const intl = useIntl();
  const store = defaultStoreUtils.useStore();

  const database = defaultStoreUtils.useEqualSelector((state) => {
    return selectDatabaseByContentIdRequired(state, { contentId });
  });

  useEffect(() => {
    if (view.settings.filter) {
      Promise.all(
        getFilteredValuesWithContext(database, view.settings.filter).map(
          async (context) => {
            await loadDependenciesAsync(
              {
                contentId: context.database.contentId,
                field: context.field,
                entryId: context.entry.id,
                value: context.value,
              },
              store,
              intl
            );
          }
        )
      );
    }
  }, [database, intl, store, view.settings.filter]);
};
